import React, {Component} from "react";
import {GET_ADDRESS_FROM_COORDINATES} from "../../../../../configs";
import Axios from "axios";
import 'framework7-icons';
import toast, {Toaster} from "react-hot-toast";

class GpsSelector extends Component {
	static contextTypes = {
		router: () => null,
	};

	state = {
		gps_loading: false,
	};


	getMyLocation = () => {
		// toast.success('Fetching your current location', { duration: 1000, position: "bottom-center" })

		let self = this;
		toast.promise(new Promise(async function (resolve, reject){


			self.startLoading();

			const location = navigator && navigator.geolocation;
		if (location) {
			await location.getCurrentPosition(
				(position) => {
					self.reverseLookup(position.coords.latitude, position.coords.longitude);
					resolve();
				},
				(error) => {
					self.setState({ gps_loading: false });
					self.stopLoading();
					console.log(error);
					if (navigator.userAgent !== "FoodomaaAndroidWebViewUA") {
						// alert("");
						reject();
						// toast.error('Please make sure your gps location is turned on.', { duration: 3000, position: "bottom-center" })

					}
				},
				{ timeout: 5000 }
			);
		} else {
			this.stopLoading();
			reject();
		}

		}),{
			loading: 'Fetching your current location',
			success: 'Location has been fetched',
			error: 'Please make sure your gps location is turned on.',
		});


	};

	reverseLookup = (lat, lng) => {
		Axios.post(GET_ADDRESS_FROM_COORDINATES, {
			lat: lat,
			lng: lng,
		})
			.then((response) => {
				console.log(response);
				const myLocation = [
					{
						formatted_address: response.data,
						geometry: {
							location: {
								lat: lat,
								lng: lng,
							},
						},
					},
				];
				this.handleGeoLocationClick(myLocation);
			})
			.catch(function(error) {
				console.warn(error.response.data);
			});
	};

	handleGeoLocationClick = (results) => {
		const saveGeoLocation = new Promise((resolve) => {
			localStorage.setItem("geoLocation", JSON.stringify(results[0]));
			resolve("GeoLocation Saved");
		});
		saveGeoLocation.then(() => {
			this.stopLoading();
			if (this.props.fetchGpsAutomaticallyAndroid) {
				//set user location but with business flag (do not redirect to address saving)
				const userSetAddress = {
					lat: JSON.parse(localStorage.getItem("geoLocation")).geometry.location.lat,
					lng: JSON.parse(localStorage.getItem("geoLocation")).geometry.location.lng,
					address: JSON.parse(localStorage.getItem("geoLocation")).formatted_address,
					house: null,
					tag: null,
					businessLocation: true,
				};
				const saveUserSetAddress = new Promise((resolve) => {
					localStorage.setItem("userSetAddress", JSON.stringify(userSetAddress));
					localStorage.setItem("userAlreadySelectedLocation", "true");
					resolve("Location Saved");
				});
				saveUserSetAddress.then(() => {
					window.location.reload();
				});
			} else {
				this.context.router.history.push("/my-location");
			}
		});
	};

	startLoading = () => {
		document.getElementById("gpsLoadingScreen").classList.remove("hidden");
	};

	stopLoading = () => {
		document.getElementById("gpsLoadingScreen").classList.add("hidden");
	};

	render() {
		return (
			<React.Fragment>

				<Toaster position={"bottom-center"} containerClassName="custom-toast-position"/>

			{/*	<div
					className="p-15 d-flex justify-content-center align-items-center gps-selection-block"
					style={{
						backgroundColor: localStorage.getItem("cartColorBg"),
						color: localStorage.getItem("cartColorText"),
						position: "relative",
					}}
					onClick={this.getMyLocation}
				>
					{<div className="mr-15">
						<p className="mb-0">Turning on Device Location will ensure accurate address and hassle free delivery</p>
					</div>}
					<div className="useGpsBtn">Use Current Location</div>
					<Ink duration="500" />
				</div>*/}
				<button onClick={this.getMyLocation} className={`btn btn-lg btn-block dl-btn `} style={{position:"relative", margin: "15px", width: "90%", height: "50px"}}>
					{/*<i className={`f7-icons`} style={{
					position: "absolute",
					left: "20%",
					top: "27%",
					fontSize: "22px"
				}}>location</i>*/} Use Current location</button>
			</React.Fragment>
		);
	}
}

export default GpsSelector;
